<template>
	<template v-for="ctrl in sidebarControls" :key="ctrl.name || ctrl.key">
		<!-- checkbox -->
		<div v-if="ctrl.type === 'checkbox'" class="field-checkbox flex mt-2">
			<i-check-box
				:name="ctrl.name"
				v-model="meta.item[ctrl.name]"
				:true-value="ctrl.trueValue != null ? ctrl.trueValue : 1"
				:false-value="ctrl.falseValue != null ? ctrl.falseValue : 0"
			/>
			<label class="ml-2">{{ ctrl.label }}</label>
		</div>
		<!-- extra button -->
		<Button v-else-if="ctrl.type === 'button'" type="button" raised severity="success"
			class="submit-btn btns mb-2 mt-2" @click="runControl(ctrl)">
			<Icon type="favicon" :icon="ctrl.icon" class="save-icon" />
			<span class="ml-2">{{ ctrl.label }}</span>
		</Button>
	</template>
	<Button type="submit" raised severity="success" class="submit-btn btns mb-2" autofocus>
		<span class="save-action text-center">
			<Icon type="favicon" :icon="AppIcons.SAVE_TICK" class="save-icon" />
			<span class="ml-2">{{ $t(isSubmitting ? 'saving' : service?.actionTitle || 'save') }}</span>
			<ProgressSpinner v-if="isSubmitting" style="margin-left: 10px; width: 12px; height: 12px" strokeWidth="6"
				fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />
		</span>
	</Button>

	<Button outlined severity="danger" @click="$emit('close')" class="tabs-btn2 btns">
		<span class="save-action text-center">
			<Icon type="favicon" :icon="AppIcons.CROSS" />
			<span class="ml-2">{{ $t('cancel') }}</span>
		</span>
	</Button>
</template>

<script>
import { AppIcons } from '../../../constants/app-icons';

export default {
	inject: ['service', 'meta'],
	props: ['modelValue', 'current', 'isLoading', 'isSubmitting'],
	data() {
		return {
			AppIcons
		}
	},
	computed: {
		sidebarControls() {
			return (this.service.sidebarControls ?? []).filter((c) => {
				if (c.editOnly && this.meta?.key !== 'edit') return false;
				return true;
			});
		},
	},
	created() {
		if (!this.meta.item) this.meta.item = {};
		this.sidebarControls
			.filter((c) => c.type === 'checkbox')
			.forEach((c) => {
				if (this.meta.item[c.name] == null) {
					this.meta.item[c.name] = c.falseValue != null ? c.falseValue : 0;
				}
			});
	},
	methods: {
		closedWindow() {
			this.emitter.emit('close-window', this.current)
		},
		useAddress() {
			this.emitter.emit('address-use', this.current)
		}
	}
}
</script>

<style></style>
